<template>
	<div class="cms-content">
		<div class="segmented-control-wrapper">
			<div class="container-title">
				<h2 class="heading-2">{{ $t('interests') }}</h2>
				<ja-button
					v-if="showCreate && isEnable"
					name="save"
					class="small"
					@click.native.prevent="onCreateNew"
					>{{ $t('createNew') }}</ja-button
				>
			</div>
			<!-- Table Interests -->
			<ja-interest-table
				v-if="showCreate && interestData"
				:data="interestData"
				@editRow="handleEditRow"
				@deleteRow="handleDeleteRow"
			></ja-interest-table>
			<!-- Create new Interests -->
			<ja-create-new-interest
				v-if="!showCreate"
				:data-edit="dataEdit"
				:data="interestData"
				@save-question="handleSaveInterest"
				@cancel="handleCancel"
			></ja-create-new-interest>
		</div>
	</div>
</template>
<script>
import Button from '@/components/ui/Button';
import InterestTable from './InterestTable.vue';
import CreateNewInterest from './CreateNewInterest.vue';
import InterestsService from '@/services/cms/InterestsService';
import AdminFacility from '@/mixins/AdminFacility';

export default {
	components: {
		jaInterestTable: InterestTable,
		jaCreateNewInterest: CreateNewInterest,
		jaButton: Button
	},
	mixins: [AdminFacility],
	props: {},
	data() {
		return {
			showCreate: true,
			interestData: null,
			dataEdit: null
		};
	},
	computed: {
		isEnable() {
			return (
				(this.isSuperAdmin || this.isSuperAdmin) && this.selectedFacilityId == 0
			);
		},
		isReturnOption() {
			return this.$store.state.isReturnOption;
		}
	},
	watch: {
		selectedFacility() {
			this.$store.commit('setLoading', true);
			this.showCreate = true;
			this.getInterests();
		},
		isReturnOption(newValue) {
			if (newValue === true) {
				this.showCreate = true;
			} else {
				this.showCreate = false;
			}
		}
	},
	mounted() {
		this.$store.commit('setLoading', true);
		this.getInterests();
	},
	methods: {
		async getInterests() {
			const data = await InterestsService.getAll();
			this.interestData = data.sort((a, b) => (a.name < b.name ? -1 : 1));
			this.$store.commit('setLoading', false);
		},
		async onCreateNew() {
			const data = await InterestsService.getById();
			this.dataEdit = data;
			this.showCreate = false;
			this.$store.commit('setIsReturnOption', false);
		},
		async handleEditRow(rowData) {
			const data = await InterestsService.getById(rowData.interest_ID);
			this.dataEdit = data;
			this.showCreate = false;
			this.$store.commit('setIsReturnOption', false);
		},
		async handleDeleteRow(rowData) {
			this.$store.commit('setLoading', true);
			await InterestsService.deleteById(rowData.interest_ID);
			await this.getInterests();
		},
		async handleSaveInterest(interest) {
			this.$store.commit('setLoading', true);
			await InterestsService.update(interest);
			await this.getInterests();
			this.showCreate = true;
		},
		async handleCancel() {
			this.$store.commit('setLoading', true);
			await this.getInterests();
			this.showCreate = true;
		}
	}
};
</script>
<style lang="scss" scoped>
.container-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.cms-content {
	margin: auto;
	max-width: 1000px;
	margin-top: 32px;
	margin-bottom: 32px;
}
</style>
